import { FaCheck } from 'react-icons/fa'

function Step({
  number,
  title,
  active,
  completed,
  className,
}: {
  number: number
  title: string
  active: boolean
  completed: boolean
  className?: string
}) {
  return (
    <div className={`flex items-center gap-2  ${className}`}>
      <div
        className={`w-6 h-6 flex items-center justify-center rounded-full border-2 ${
          completed
            ? 'bg-[#000D33] border-[#000D33] text-white'
            : active
              ? 'bg-[#000D33] border-[#000D33] text-[#FFFFFF]'
              : 'border-[#D9D9D9] bg-[#D9D9D9] text-[#FFFFFF]'
        }`}
      >
        {completed ? <FaCheck size={12} /> : number}
      </div>
      <span
        className={`text-base ${active || completed ? 'font-semibold text-black ' : 'text-[#D9D9D9] max-md:hidden'}`}
      >
        {title}
      </span>
    </div>
  )
}

export default function Stepper({ step }: { step: number }) {
  return (
    <div className='w-[60%] flex items-center justify-between m-auto'>
      {/* Step 1 */}
      <Step
        number={1}
        title='Stay Selection'
        active={step === 1}
        completed={step >= 1}
        className='max-md:hidden'
      />

      {/* Line */}
      <div className='flex-1 h-0.5 bg-[#868686] mx-2 max-md:hidden' />

      {/* Step 2 */}
      <Step
        number={2}
        title='Guest Info'
        active={step === 2}
        completed={step >= 2}
      />

      {/* Line */}
      <div className='flex-1 h-0.5 bg-[#868686] mx-2' />

      {/* Step 3 */}
      <Step
        number={3}
        title='Checkout'
        active={step === 3}
        completed={step >= 3}
      />
    </div>
  )
}
